exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adres-defteri-sec-card[data-v-ea1cad6e]{border-radius:8px}.adres-defteri-toolbar-search[data-v-ea1cad6e]{max-width:360px}.adres-defteri-table[data-v-ea1cad6e]{border-top:1px solid #eee}", ""]);

// exports
